import { ReactElement } from 'react'
import {
  ReceiptDivider,
  ReceiptLabel,
  ReceiptTextRow,
  ReceiptValue,
} from '../../printStyles'
import { I18n } from 'common'
import { Order } from '../../../../../../../../src/api/cart/interfaces'

interface Props {
  locationName: string
  order: Order
  isMyPlaceOrder: boolean
}

const LocationInfo = (props: Props): ReactElement => {
  const { locationName, order, isMyPlaceOrder } = props

  const orderType = order?.deliveryDetail?.deliveryMethod
  const transport = order?.deliveryDetail?.carrier

  return (
    <ReceiptTextRow>
      <ReceiptLabel>
        <I18n name="location" />
      </ReceiptLabel>
      <ReceiptValue>{locationName}</ReceiptValue>

      {isMyPlaceOrder && orderType && (
        <>
          <ReceiptDivider>|</ReceiptDivider>
          <ReceiptLabel>
            <I18n name="orderType" />
          </ReceiptLabel>
          <ReceiptValue>{orderType}</ReceiptValue>
        </>
      )}

      {isMyPlaceOrder && transport && (
        <>
          <ReceiptDivider>|</ReceiptDivider>
          <ReceiptLabel>
            <I18n name="transport" />
          </ReceiptLabel>
          <ReceiptValue>{transport}</ReceiptValue>
        </>
      )}
    </ReceiptTextRow>
  )
}

export default LocationInfo
